export default __webpack_public_path__ + "static/media/colocado-9.beb17f10.jpg";